export { SeatsIcon } from "./seats";
